var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.parsedHours != 0)?_c('span',[_vm._v(" "+_vm._s(_vm.parsedHours)+" hour"+_vm._s(_vm.hoursSuffix)+" ")]):_vm._e(),(_vm.parsedMinutes != 0)?_c('span',[_vm._v(" "+_vm._s(_vm.parsedMinutes)+" minute"+_vm._s(_vm.minutesSuffix)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }